import React from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
// import { useTranslation } from "react-i18next";

const TableContainer = ({ children, heading }) => {

  //const [translation] = useTranslation("translations");

  return (
    <Card
      className={`bg-transparent my-summary-table ${window.location.pathname === "/" ? '' : 'mt-3'}`}
      border="light"
      style={{ borderWidth: 1, minHeight: '470px' }}
    >
      <Card.Body>
        {window.location.pathname === "/" &&

            <div className="d-flex">
              <h5 className="mb-3 flex-grow-1">Mitt fokus</h5>
              <Link to="/my-tasks/" className="text-secondary d-inline-block text-decoration-none" style={{ fontSize: "0.9rem" }}>
                <span className="pe-2">Visa hela</span>
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
              </Link>
            </div>
        }
        {window.location.pathname !== "/" &&
          <Card.Title style={{ fontWeight: "bold" }}>{heading}</Card.Title>
        }
        
        {children}
      </Card.Body>
    </Card>
  );
};

export default TableContainer;
